var _path, _rect, _path2, _rect2, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutomatedMessages = function SvgAutomatedMessages(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#35333C",
    d: "M8.404 11.974l5.673 6.052M8.782 11.596l5.295-5.673M7.648 11.974h6.43"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.877,
    height: 2.877,
    x: 5.5,
    y: 13.366,
    fill: "#fff",
    stroke: "#35333C",
    rx: 0.5,
    transform: "rotate(-90 5.5 13.366)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.849,
    cy: 17.979,
    r: 1.438,
    fill: "#fff",
    stroke: "#35333C",
    transform: "rotate(-90 14.85 17.979)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.438,
    fill: "#fff",
    stroke: "#35333C",
    transform: "matrix(0 1 1 0 14.85 5.939)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.849,
    cy: 11.927,
    r: 1.438,
    fill: "#fff",
    stroke: "#35333C",
    transform: "rotate(-90 14.85 11.927)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutomatedMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/automated-messages.193f7cb655abd77bd6a20dec63509082.svg";